<template>
  <ValidationObserver class="col-12 col-md-8" ref="observer">
    <v-layout row wrap class="mt-5">
      <v-layout row wrap class="pr-0 pb-4">
        <v-flex xs8 class="pl-0">
          <ValidationProvider class="pl-0" name="บ้านเลขที่" :rules="'required'" v-slot="{ errors }">
            <v-text-field dense type="text" v-model="address.addressNo" autocomplete="off" label="บ้านเลขที่" outlined :errorMessages="errors"></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="p-0">
          <ValidationProvider class="pl-0" name="ชั้น" v-slot="{ errors }">
            <v-text-field dense type="text" v-model="address.floor" autocomplete="off" label="ชั้น" outlined :errorMessages="errors"></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
      <v-flex xs12 class="pl-0 pb-4">
        <v-text-field dense type="text" v-model="address.building" autocomplete="off" label="ตึก" outlined></v-text-field>
      </v-flex>
      <v-layout row wrap class="pr-0 pb-4">
        <v-flex xs8 class="pl-0">
          <v-text-field dense type="text" v-model="address.roomNo" autocomplete="off" label="ห้อง" outlined></v-text-field>
        </v-flex>
        <v-flex xs4 class="p-0">
          <ValidationProvider class="pl-0" name="หมู่" :rules="'moo'" v-slot="{ errors }">
            <v-text-field dense type="text" v-model="address.moo" autocomplete="off" label="หมู่" outlined :errorMessages="errors"></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
      <v-flex xs12 class="pl-0 pb-4">
        <ValidationProvider class="pl-0" name="ซอย" :rules="'required'" v-slot="{ errors }">
          <v-text-field dense type="text" v-model="address.soi" autocomplete="off" label="ซอย" outlined :errorMessages="errors"></v-text-field>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 class="pl-0">
        <ValidationProvider class="pl-0" name="ถนน" :rules="'required'" v-slot="{ errors }">
          <v-text-field dense type="text" v-model="address.street" autocomplete="off" label="ถนน" outlined :errorMessages="errors"></v-text-field>
        </ValidationProvider>
      </v-flex>
      <ValidationProvider class="pl-0" name="รหัสไปรษณีย์" :rules="'required'" v-slot="{ errors }">
        <ThaiAddressInput label="รหัสไปรษณีย์" :inputtype="'number'" @select="onSelectAddress" class="mt-5" v-model="address.postCode" :type="'zipcode'" :errorMessages="errors" :texttype="'number'"></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider class="pl-0" name="เขต" :rules="'required'" v-slot="{ errors }">
        <ThaiAddressInput label="เขต" :inputtype="'text'" @select="onSelectAddress" class="mt-5" v-model="address.district" :type="'amphoe'" :errorMessages="errors" :texttype="'text'"></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider class="pl-0" name="แขวง" :rules="'required'" v-slot="{ errors }">
        <ThaiAddressInput label="แขวง" :inputtype="'text'" @select="onSelectAddress" class="mt-5" v-model="address.subDistrict" :type="'district'" :errorMessages="errors" :texttype="'text'"></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider class="pl-0" name="จังหวัด" :rules="'required'" v-slot="{ errors }">
        <ThaiAddressInput label="จังหวัด" :inputtype="'text'" @select="onSelectAddress" class="mt-5" v-model="address.city" :type="'province'" :errorMessages="errors" :texttype="'text'"></ThaiAddressInput>
      </ValidationProvider>
    </v-layout>
    <div v-if="option" class="my-3">
      <v-divider class="my-5"></v-divider>
      <div class="text-blue">ใช้ที่อยู่นี้เป็นที่อยู่จัดส่งเอกสารหรือไม่</div>
      <ValidationProvider class="pl-0" name="ที่อยู่จัดส่งเอกสาร" :rules="'required'" v-slot="{ errors }">
        <v-radio-group v-model="address.isMaillingAddress" :errorMessages="errors">
          <v-radio label="ใช่" :value="true"></v-radio>
          <v-radio label="ไม่ใช่" :value="false"></v-radio>
        </v-radio-group>
      </ValidationProvider>
    </div>
    <v-checkbox label="ข้าพเจ้าขอรับรองว่า ข้อความข้างต้นเป็นความจริงทุกประการ" v-model="checkbox" value="true"></v-checkbox>
    <div style="text-align: center;" class="mt-5">
      <v-btn :loading="loading" class="main-btn col-10 sm-8" :disabled="!checkbox" @click="submit" color="#23409a"> <span class="text-white">ยืนยัน</span> </v-btn>
    </div>
  </ValidationObserver>
</template>

<script>
import { extend } from "vee-validate";
import ThaiAddressInput from "./ThaiAddressInput.vue";

extend("moo", {
  message: "รูปหมู่ไม่ถูกต้อง",
  validate: (value) => {
    let fullMatch = value.match(/\b([1-9]|[1-9][0-9]|[1-9][0-9][0-9])\b/g);
    return fullMatch && fullMatch[0].length == value.length;
    // if (fullMatch[0].length == value.length) {
    // }
  },
});

export default {
  components: { ThaiAddressInput },
  props: {
    loading: {
      default: false,
    },
    option: {
      default: false,
    },
  },
  data() {
    return {
      lang: "th",
      address: {
        addressNo: "",
        floor: "",
        postCode: "",
        district: "",
        subDistrict: "",
        city: "",
        moo: "",
        soi: "",
        roomNo: "",
        building: "",
        street: "",
        isMaillingAddress: null,
      },
      checkbox: false,
    };
  },
  computed: {
    word() {
      return {
        name: this.lang && this.lang == "en" ? "Name" : "ชื่อ",
        surname: this.lang && this.lang == "en" ? "Surname" : "นามสกุล",
        phoneno: this.lang && this.lang == "en" ? "Tell" : "เบอร์โทรศัพท์",
        email: this.lang && this.lang == "en" ? "Email" : "อีเมล",
        address: this.lang && this.lang == "en" ? "Address" : "ที่อยู่",
        province: this.lang && this.lang == "en" ? "Province" : "จังหวัด",
        district: this.lang && this.lang == "en" ? "District" : "แขวง",
        county: this.lang && this.lang == "en" ? "County" : "เขต",
        postcode: this.lang && this.lang == "en" ? "Postcode" : "รหัสไปรษณีย์",
        loginDone: this.lang && this.lang == "en" ? "Registration Success" : "ลงทะเบียนสำเร็จ",
      };
    },
  },

  mounted() {
    //   this.setup()
  },
  methods: {
    async submit() {
      if (await this.$refs.observer.validate()) {
        let result = await this.$swal.fire({
          title: "ยืนยันการแก้ไขที่อยู่หรือไม่",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          customClass: {
            header: "header-class",
            title: "fs-19 text-blue",
            content: "fs-16",
            confirmButton: "main-btn col-10 m-0 fs-14 bg-blue",
            cancelButton: "main-btn col-10 m-0 fs-14 mysilver mt-3",
            actions: "p-0 w-100 d-flex flex-row justify-content-center",
          },
        });
        if (result.value) {
          this.$emit("submit", this.address);
        }
      }
    },
    onSelectAddress(address) {
      this.address.district = address.amphoe;
      this.address.city = address.province;
      this.address.subDistrict = address.district;
      this.address.postCode = address.zipcode;
    },
  },
};
</script>

<style></style>
